import classNames from "classnames";
import "./NavGroup.scss";

type NavGroupProps = {
	children: React.ReactNode;
	className?: string;
};

const NavGroup = ({ children, className }: NavGroupProps) => {
	return <ul className={classNames("nav__group", className)}>{children}</ul>;
};

export default NavGroup;
